// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1g6mw","selected":"Chip_selected__1mOKR"};